/***********************************************************
Alexander Self
8/22/17
Gang Reducer: Manages and creation and editing of gangs
***********************************************************/
import { FETCH_TIMESHEET_DATA, FETCH_EQUIPMENT, SELECT_EQUIPMENT } from '../actions/types';

const initState = {
  equipmentNo: [],
  equipmentTrailerNo: [],
  selectedEquipment: {},
  create: {},
  edit: {}
};



export default function EquipmentReducer(state=initState, action) {
  switch (action.type) {
    case FETCH_TIMESHEET_DATA:
      return { ...state,
        equipmentNo: action.payload.equipmentNo,
        equipmentTrailerNo: action.payload.equipmentTrailerNo
      };
    case FETCH_EQUIPMENT:
      return { ...state,
        equipmentNo: action.payload.equipmentNo,
        equipmentTrailerNo: action.payload.equipmentTrailerNo
      };
    case SELECT_EQUIPMENT:
      return { ...state,
        selectEquipment: action.payload
      };
    default:
      return state;
  }
}


/* END */



// WEBPACK FOOTER //
// ./src/reducers/equipment_reducer.js